import React, { useState } from "react";
import TaskItem from "./TaskItem";
import KanbanColumn from "./KanbanColumn";
import { useAppSelector } from "../../../Core/redux/hooks";
import TaskCard, { NewtaskCard } from "./TaskCard";
import KanbanItem from "./KanbanItem";
import CustomBadge from "../../../Core/CommonV2/CustomBadge";

const SubtaskKanbanBoard = ({
  task,
  board,
  statusArray,
  handleFilter,
  changeTaskStatus,
}) => {
  const { showNewTaskCard } = useAppSelector((state) => state.myBoard);
  const { labels } = useAppSelector((state) => state.schedule);
  const [showSubtasks, setShowSubTasks] = useState(true);
  const option = labels
    ?.filter((item) => item.isMyBoard)
    .map((label) => {
      return {
        id: label.id,
        value: label.id,
        label: label.name,
        render: () => (
          <div className="flex items-center justify-between">
            <CustomBadge
              text={label.name}
              color={label.color}
              className="border border-gray-200"
              style={{ borderColor: label.color }}
            />
            <div className="h-[14px] w-[14px] rounded-full" />
          </div>
        ),
      };
    });

  return (
    <div className=" first:mt-[10px]  ">
      <TaskItem
        key={task.id}
        task={task}
        id={`${task.id}`}
        labelOptions={option}
        showSubtaskKanbanBoard={showSubtasks}
        setShowSubtaskKanbanBoard={setShowSubTasks}
      />
      {showSubtasks && (
        <div
          data-kanbanboard={true}
          className="grid-container ml-[2px]   "
          ref={board}
        >
          {statusArray &&
            [...statusArray].map((channel, index) => (
              // todo check if removing null object any effect
              <KanbanColumn
                parentTaskId={task.id}
                key={channel.id}
                status={`${channel.id}_${task.id}_${index}`}
                channel={channel}
                changeTaskStatus={changeTaskStatus}
                className=" kanban-col "
                customPadding
              >
                {showNewTaskCard?.visible &&
                showNewTaskCard?.channel?.id === channel?.id &&
                +showNewTaskCard?.goalId === +task.id ? (
                  <NewtaskCard
                    status={channel}
                    isHovered={true}
                    defaultOpen
                    parentTaskId={task.id}
                  />
                ) : null}
                {handleFilter(task.subtask, channel).map((item) => (
                  <KanbanItem key={item.id} id={item.id}>
                    <TaskCard task={item} />
                  </KanbanItem>
                ))}
              </KanbanColumn>
            ))}
        </div>
      )}
    </div>
  );
};

export default SubtaskKanbanBoard;
